import { ArrowLeft, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <section className="flex min-h-[80vh] items-center justify-center px-4 pb-20 pt-32">
      <div className="w-full max-w-md text-center">
        <div className="mb-8">
          <p className="mb-4 text-8xl font-bold text-primary/20 sm:text-9xl" aria-hidden="true">404</p>
          <h1 className="-mt-8 text-3xl font-semibold tracking-tight text-text-primary">Stranica nije pronađena</h1>
        </div>
        <p className="mb-8 text-lg text-text-secondary">Adresa možda nije tačna ili je sadržaj u međuvremenu premešten.</p>
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Link
            to="/"
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-full bg-primary px-6 text-sm font-semibold text-on-primary transition-colors hover:bg-primary-hover"
          >
            <Home aria-hidden="true" className="size-5" />
            Početna stranica
          </Link>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-full border border-border bg-surface px-6 text-sm font-semibold text-text-primary transition-colors hover:border-primary"
          >
            <ArrowLeft aria-hidden="true" className="size-5" />
            Nazad
          </button>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;

